"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPromotedOfferView = exports.trackPageView = void 0;
exports.startTracking = startTracking;
const js_cookie_1 = __importDefault(require("js-cookie"));
const Api = __importStar(require("@src/api"));
const PAGE_VIEW_CODE_NAME = 'pracuj-tracking';
const PROMOTED_OFFER_VIEW_CODE_NAME = 'pracuj-promoted-tracking';
function getThisMidnight() {
    return new Date(new Date().setHours(24, 0, 0, 0));
}
function startTracking(name) {
    let cookie = js_cookie_1.default.get(name);
    if (!cookie) {
        const expires = getThisMidnight();
        js_cookie_1.default.set(name, '', { expires });
        cookie = js_cookie_1.default.get(name);
    }
    return cookie;
}
const trackPageView = async () => {
    try {
        let cookie = js_cookie_1.default.get(PAGE_VIEW_CODE_NAME);
        if (!cookie) {
            cookie = startTracking(PAGE_VIEW_CODE_NAME);
        }
        const { pathname } = window.location;
        const wasPathnameVisited = cookie.split(',').includes(pathname);
        if (!wasPathnameVisited) {
            const expires = getThisMidnight();
            js_cookie_1.default.set(PAGE_VIEW_CODE_NAME, `${cookie},${pathname}`, { expires });
            await Api.Analytics.incrementPageView(pathname);
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.trackPageView = trackPageView;
function checkIncrementConditions(search, wasPathnameVisited, pathname) {
    if (!search || wasPathnameVisited) {
        return false;
    }
    if (!search.includes('isPromoted=true') || !pathname.match(/(\/ponuka|\/offer)\/.+-\d+$/).length) {
        return false;
    }
    return true;
}
const trackPromotedOfferView = async () => {
    try {
        let cookie = js_cookie_1.default.get(PROMOTED_OFFER_VIEW_CODE_NAME);
        if (!cookie) {
            cookie = startTracking(PROMOTED_OFFER_VIEW_CODE_NAME);
        }
        const { search, pathname } = window.location;
        const wasPathnameVisited = cookie.split(',').includes(pathname);
        if (checkIncrementConditions(search, wasPathnameVisited, pathname)) {
            const expires = getThisMidnight();
            js_cookie_1.default.set(PROMOTED_OFFER_VIEW_CODE_NAME, `${cookie},${pathname}`, { expires });
            await Api.Analytics.incrementPromotedOfferView(pathname);
        }
    }
    catch (err) {
        console.error(err);
    }
};
exports.trackPromotedOfferView = trackPromotedOfferView;
